module.exports = __webpack_public_path__ + "img/itemBar_03.50085292.png";